import React, { type FC, type ReactElement } from 'react'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { NoticeRow } from './NoticeRow'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../../../redux/hooks'
import { type RootState } from '../../../redux/store'

export const NoticesList: FC = () => {
  const isAdmin = useAppSelector((state: RootState) => state.auth.isAdmin)
  const notices = useAppSelector((state: RootState) => state.notices.notices)

  return (
        <TableContainer>
            <Table>
                <NoticeListHeader/>
                <TableBody>
                    {[...notices] // Create a copy of the array which we then sort and map in order to not mutate the original array
                      .sort((a, b) => a.createdAt - b.createdAt)
                      .map((notice) => <NoticeRow isAdmin={isAdmin} notice={notice} key={notice.id}/>)
                    }
                </TableBody>
            </Table>
        </TableContainer>
  )
}

/* Child-components */

function NoticeListHeader(): ReactElement {
  const { t } = useTranslation()

  return (
        <TableHead>
            <TableRow>
                <TableCell>
                    <Typography>{t('notices.created')}</Typography>
                </TableCell>
                <TableCell>
                    <Typography>{t('notices.content')}</Typography>
                </TableCell>
                <TableCell>{/* Expand button */}</TableCell>
                <TableCell>{/* Delete button for admins */}</TableCell>
            </TableRow>
        </TableHead>
  )
}
